// extracted by mini-css-extract-plugin
export var deleteModal = "_q4-0";